import { createBrowserHistory } from "history";
import resolvePathname from "resolve-pathname";
const history = createBrowserHistory();

function resolvePath(path) {
  const { pathname } = this.location;
  return resolvePathname(path, `${pathname}/`).slice(0, -1);
}

function pushUp({ search, state, pathname = ".." } = {}) {
  return this.push({
    pathname: this.resolvePath(pathname),
    search,
    state,
  });
}

function replaceUp({ search, state, pathname = ".." } = {}) {
  return this.push({
    pathname: this.resolvePath(pathname),
    search,
    state,
  });
}

history.pushUp = pushUp.bind(history);
history.replaceUp = replaceUp.bind(history);
history.resolvePath = resolvePath.bind(history);

export default history;
